import _isEmpty from 'lodash/isEmpty';
import qs from 'qs';
import { supportedLocales } from 'helpers/supported-locales';

/**
 * Formats the page route correctly and allows for appending a query string
 *
 * @param {string} baseRoute
 * @param {object} query This is the query string parsed with qs.parse
 */

export const formatRoute = (baseRoute, query) => {
  if (_isEmpty(query)) {
    return baseRoute;
  }

  const supportedQuery = Object.entries(query).reduce((newQuery, [param, value]) => {
    // Only include supported languages
    if (param === 'language') {
      if (supportedLocales.includes(value)) {
        newQuery[param] = value;
      }
      return newQuery;
    }

    // Prevent duplicate params
    if (Object.prototype.hasOwnProperty.call(newQuery, param)) {
      return newQuery;
    }

    // Prevent multiple values
    newQuery[param] = Array.isArray(value) ? value[0] : value;
    return newQuery;
  }, {});

  if (_isEmpty(supportedQuery)) {
    return baseRoute;
  }

  return `${baseRoute}?${qs.stringify(supportedQuery)}`;
};
